var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "fields-checkbox"
  }, [_c("span", {
    staticClass: "info-title"
  }, [_vm._v(_vm._s(_vm.exportType === 1 ? _vm.$t("保单信息") : _vm.exportType === 2 ? _vm.$t("订单信息") : _vm.$t("理赔信息")) + "：")]), _c("div", {
    staticClass: "check-group"
  }, [_c("a-checkbox", {
    attrs: {
      indeterminate: _vm.indeterminate,
      checked: _vm.checkAll
    },
    on: {
      change: _vm.onCheckAllChange
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("全选")) + " ")]), _c("br"), _c("a-checkbox-group", {
    on: {
      change: _vm.onChange
    },
    model: {
      value: _vm.checkedList,
      callback: function ($$v) {
        _vm.checkedList = $$v;
      },
      expression: "checkedList"
    }
  }, _vm._l(_vm.plainOptions, function (item) {
    return _c("a-checkbox", {
      key: item.value,
      attrs: {
        value: item.value
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.label)) + " ")]);
  }), 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };